/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { defineFlag } from './feature-flag-registry';


export const FF_MOCK_RECAPTCHA = defineFlag(
  'FF_MOCK_RECAPTCHA',
  import.meta.env.FF_MOCK_RECAPTCHA,
  import.meta.env.DEBUG === 'true',
  'Bypasses reCAPTCHA validation in development.',
  { requiresDebug: true, isMockToggle: true },
);

export const FF_MOCK_API = defineFlag(
  'FF_MOCK_API',
  import.meta.env.FF_MOCK_API,
  import.meta.env.DEBUG === 'true',
  'Uses mock API responses instead of real backend calls.',
  { isMockToggle: true },
);

export const FF_SOCIAL_LOGIN = defineFlag(
  'FF_SOCIAL_LOGIN',
  import.meta.env.FF_SOCIAL_LOGIN,
  true,
  'Enables Google and Facebook social login buttons.',
);

export const FF_SECOND_FACTOR = defineFlag(
  'FF_SECOND_FACTOR',
  import.meta.env.FF_SECOND_FACTOR,
  true,
  'Enables two-factor authentication flow.',
);

export const FF_NATIVE_LOGIN = defineFlag(
  'FF_NATIVE_LOGIN',
  import.meta.env.FF_NATIVE_LOGIN,
  false,
  'Enables native email/password login and account creation forms.',
);

export const FF_NIGHT_MODE = defineFlag(
  'FF_NIGHT_MODE',
  import.meta.env.FF_NIGHT_MODE,
  false,
  'Enables dark/night mode theme across the application.',
);
